// Get current variant from the page
function getCurrentVariant() {
  const variantScript = document.querySelector('variant-picker script[data-variant]');
  if (variantScript) {
    try {
      return JSON.parse(variantScript.textContent);
    } catch (e) {
      return null;
    }
  }
  return null;
}

// Check and update backorder status based on current variant
function checkAndUpdateBackorderStatus(currentVariant) {
  if (!currentVariant) {
    return;
  }

  // Check if variant has zero or negative inventory and continues selling
  const hasZeroStock = currentVariant.inventory_quantity <= 0;
  const continuesSelling = currentVariant.inventory_policy === 'continue';
  
  // Get metafield value from hidden input (set by Liquid)
  const backOrderMetafield = document.querySelector('[data-backorder-metafield]');
  const metafieldEnabled = backOrderMetafield && backOrderMetafield.value === 'true';

  // Show backorder if: zero stock AND continues selling AND metafield enabled
  if (hasZeroStock && continuesSelling && metafieldEnabled) {
    // Update stock status - show "Backorder" in red
    const stockStatus = document.querySelector('#product-form-stock');
    if (stockStatus) {
      stockStatus.textContent = 'Backorder';
      stockStatus.classList.add('stock-status');
      stockStatus.classList.remove('inventory--high');
    }
    
    // Hide pickup details
    const pickupDetailsDiv = document.querySelector('.store-pickup-details');
    if (pickupDetailsDiv) {
      pickupDetailsDiv.style.display = 'none';
    }
    
    const pickupDetailslink = document.querySelector('.store-availability-container');
    if (pickupDetailslink) {
      pickupDetailslink.style.display = 'none';
    }

    // Update button text
    const button = document.querySelector('.product-form__add-button');
    if (button && !button.disabled) {
      button.innerText = 'Place Backorder';
    }
  } else {
    // Show pickup details if conditions not met
    const pickupDetailsDiv = document.querySelector('.store-pickup-details');
    if (pickupDetailsDiv) {
      pickupDetailsDiv.style.display = 'block';
    }
  }
}

// Initialize - only handle variant changes, not initial load (Liquid handles that)
function init() {
  const form = document.querySelector('.product-form');
  if (!form) {
    return;
  }

  // Listen for variant changes
  form.addEventListener('variant:changed', function(event) {
    const variant = event.detail?.variant;
    if (variant) {
      setTimeout(() => {
        checkAndUpdateBackorderStatus(variant);
      }, 50);
    }
  });

  form.addEventListener('variant:change', function(event) {
    const variant = event.detail?.variant;
    if (variant) {
      setTimeout(() => {
        checkAndUpdateBackorderStatus(variant);
      }, 50);
    }
  });

  // Listen for product rerender
  form.addEventListener('product:rerender', function() {
    setTimeout(() => {
      const currentVariant = getCurrentVariant();
      if (currentVariant) {
        checkAndUpdateBackorderStatus(currentVariant);
      }
    }, 100);
  });
}

// Wait for DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  setTimeout(init, 100);
}
